import { render } from "./WelcomeItem.vue?vue&type=template&id=d3dcc89a&scoped=true"
const script = {}

import "./WelcomeItem.vue?vue&type=style&index=0&id=d3dcc89a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3dcc89a"]])

export default __exports__